/*
 * Package: WebVideo.StringUtils
 * Version: $Id$
 * Copyright (c) 2011-2017 Sergey Leonov
 */

function StringUtils() {}

/*
 * encode HTML characters
 */
StringUtils.replaceHtmlChars = function(text) {
  return text.replace(/& /g,'&amp; ').replace(/</g,'&lt;').replace(/>/g,'&gt;');
};

/*
 * objectToString
 */
StringUtils.objectToString = function(obj) {
  if(typeof(obj) == 'object') {
    var res = "";
    for(var key in obj) {
      res += res.length>0?',\n':'';
      res += key +": " + StringUtils.objectToString(obj[key]);
    }
    return '{\n'+res+'\n}';
  } else {
    return ""+obj;
  }
};

/*
 * NVL
 */
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}
StringUtils.NVL = function(value, defaultValue) {
  if(
     typeof(value) == 'undefined' ||
     value == null ||
    (typeof(value) == 'string' && value.trim().length == 0)
  ) {
    return defaultValue;
  }

  return value;
};

/*
 * formatSize
 */
StringUtils.formatSize = function(bytes) {
  bytes = Math.floor(bytes);
  var kb = new Number(bytes / 1024).toFixed(2);
  var mb = new Number(bytes / (1024 * 1024)).toFixed(2);
  if(mb >= 1) {
    return mb + ' Mb';
  } else if(kb >= 1) {
    return kb + ' Kb';
  } else {
    return bytes + ' b';
  }
};

/*
 * toString
 */
StringUtils.toString = function(arr, separator) {
  var str = '';
  for (var i=0; i<arr.length; i++) {
    str += arr[i];
    if (i<arr.length-1) str += separator;
  }
  return str;
};

/*
 * When you initialize an array with a number, it creates an array with the length set to that value so that the array appears to contain that many undefined elements.
 * Though some Array instance methods skip array elements without values, .join() doesn't, or at least not completely; it treats them as if their value is the empty string.
 * Thus you get a copy of the zero character (or whatever "z" is) between each of the array elements; that's why there's a + 1 in there.
 */
StringUtils.pad = function(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};

StringUtils.formatDouble = function(value, digits) {
  var precision = (Config.minimumFractionDigits == 0) ? (value%1 == 0 ? Config.minimumFractionDigits : digits) : digits;
  var thousandsSep = Config.defaultUseGrouping ? " " : "";
  return accounting.formatNumber(value, precision, thousandsSep, ".");
};

StringUtils.base64ToBlob = function(base64, mimeType) {
  const base64Data = base64.split(',')[1] || base64;
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};

StringUtils.base64ToFile = function(base64, filename, mimeType) {
  const blob = StringUtils.base64ToBlob(base64, mimeType);
  return new File([blob], filename, { type: mimeType });
};

/*
* deprecated:
*/
StringUtils.getGMTTimeZone = TimeUtils.getGMTTimeZone;
StringUtils.getSiteDefaultTimeZone = function() {
  return StringUtils.NVL(Config.defaultTimezone, 'America/Los_Angeles'); //Pacific Time
};